import PassengerSeat from './passenger-seat-component';

import './passenger-seat.scss';

const MODULE_NAME = 'app.flight.passenger-seat';
const module = angular.module(MODULE_NAME, [])
    .directive(PassengerSeat.DIRECTIVE_NAME, PassengerSeat);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/flights/passenger-seat/passenger-seat-module.js